<ex-dropdown-v2 class="doc-row-menu">
  <ng-template exDropdownV2Header let-toggle="toggle" let-open="open">
    <button
      type="button"
      class="doc-row-menu__trigger"
      [class.doc-row-menu__trigger--open]="open"
      (click)="toggle()"
      [attr.aria-label]="'tenders.responses.documents.row-menu' | translate"
    >
      <i class="ph ph-dots-three-vertical" aria-hidden="true"></i>
    </button>
  </ng-template>
  <ng-template exDropdownV2Content let-toggle="toggle">
    <div class="doc-row-menu__list">
      @if (showView) {
        <button type="button" class="doc-row-menu__item" (click)="onView(toggle)">
          <i class="ph ph-eye" aria-hidden="true"></i>
          {{ 'tenders.responses.documents.action-view' | translate }}
        </button>
      }
      @if (showDownload) {
        <button type="button" class="doc-row-menu__item" (click)="onDownload(toggle)">
          <i class="ph ph-download-simple" aria-hidden="true"></i>
          {{ 'tenders.responses.documents.action-download' | translate }}
        </button>
      }
      @if (showDelete) {
        <button type="button" class="doc-row-menu__item doc-row-menu__item--danger" (click)="onDelete(toggle)">
          <i class="ph ph-trash" aria-hidden="true"></i>
          {{ 'tenders.responses.documents.action-delete' | translate }}
        </button>
      }
    </div>
  </ng-template>
</ex-dropdown-v2>
